import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { getAccessToken, ApiScope } from '../silentAuth'
import { apiConfig } from '../../config'



export const HubConnection = new HubConnectionBuilder()
  .withUrl(apiConfig.alarmHubUrl,{ accessTokenFactory: () => getAccessToken(ApiScope) })
  .withAutomaticReconnect()
  .configureLogging(LogLevel.Information)
  .build();
